"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/AttachmentTray.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);











const TrayItem = _react.memo.call(void 0, ({ pending: { id, file }, onRemove }) => {
  const [thumbnail, setThumbnail] = _react.useState(null)
  const remove = _react.useCallback.call(void 0, () => onRemove(id), [onRemove, id])
  // A format the browser can't draw (HEIC, say) falls back to the chip.
  const dropThumbnail = _react.useCallback.call(void 0, () => setThumbnail(null), [])

  _react.useEffect.call(void 0, () => {
    if (!file.type.startsWith('image/')) return undefined
    const url = URL.createObjectURL(file)
    setThumbnail(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  return (
    _react2.default.createElement('li', { className: "attachment-tray--item", title: file.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
      , thumbnail
        ? _react2.default.createElement('img', { className: "attachment-tray--thumbnail", src: thumbnail, alt: file.name, onError: dropThumbnail, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}} )
        : (
          _react2.default.createElement('span', { className: "attachment-tray--file", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, "insert_drive_file")
            , _react2.default.createElement('span', { className: "attachment-tray--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}, file.name)
          )
        )
      , _react2.default.createElement('button', {
        type: "button",
        className: "attachment-tray--remove",
        'aria-label': `Remove ${file.name}`,
        onClick: remove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
, "✕"

      )
    )
  )
})
TrayItem.displayName = 'TrayItem'






// Files waiting above the composer. Nothing is uploaded until Send.
const AttachmentTray = ({ files, onRemove }) => (
  _react2.default.createElement('ul', { className: "attachment-tray", 'aria-label': "Files to send"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
    , files.map(pending => _react2.default.createElement(TrayItem, { key: pending.id, pending: pending, onRemove: onRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}} ))
  )
)

exports. default = _react.memo.call(void 0, AttachmentTray)
